import React from 'react';

interface FormControlSublabelProps {
  label: string;
  children: React.ReactNode;
}

const FormControlSublabel = ({ label, children }: FormControlSublabelProps) => (
  <>
    <span className='form__control__sublabel'>{label}</span>
    {children}
  </>
);

export default FormControlSublabel;
